/* eslint-disable */
import {
  Grid,
  Checkbox,
  FormControlLabel,
  TextField,
  Select,
  MenuItem,
  Typography,
  Paper,
  FormControl,
  InputLabel,
  IconButton,
  OutlinedInput,
  InputAdornment,
} from "@mui/material";
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import { DatePicker } from "@mui/x-date-pickers";
import { Box } from "@mui/system";
import { useContext, useEffect, useState } from "react";
import GestionAtencionContext from "../../../project/contexts/GestionAtencionContext";
import Message from "../../../project/utils/Message";
import { getCacheData } from "../../services/CacheService";

import { getInstitutos } from "../../../project/services/InstitutoService";
//
// ################################################################################
//
const Receta = () => {
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [medicos, setMedicos] = useState([]);
  const [institutos, setInstitutos] = useState([]);

  const {
    prismaOptions,
    recetaLejos,
    recetaLejosDisabled,
    handleChangeRecetaLejos,
    recetaCerca,
    recetaCercaDisabled,
    handleChangeRecetaCerca,
    recetaIntermedia,
    recetaIntermediaDisabled,
    handleChangeRecetaIntermedia,
    recetaOtrosDatos,
    handleChangeRecetaOtrosDatos,
    handleChangeRecetaOtrosDatosFechaReceta,
    errorLejosOdEsfera,
    setErrorLejosOdEsfera,
    errorLejosOdCilindro,
    setErrorLejosOdCilindro,
    errorLejosOdEje,
    setErrorLejosOdEje,
    errorLejosOdPrisma,
    setErrorLejosOdPrisma,
    errorLejosOdEjePrisma,
    setErrorLejosOdEjePrisma,
    errorLejosOiEsfera,
    setErrorLejosOiEsfera,
    errorLejosOiCilindro,
    setErrorLejosOiCilindro,
    errorLejosOiEje,
    setErrorLejosOiEje,
    errorLejosOiPrisma,
    setErrorLejosOiPrisma,
    errorLejosOiEjePrisma,
    setErrorLejosOiEjePrisma,
    errorCercaOdEsfera,
    setErrorCercaOdEsfera,
    errorCercaOdCilindro,
    setErrorCercaOdCilindro,
    errorCercaOdEje,
    setErrorCercaOdEje,
    errorCercaOdPrisma,
    setErrorCercaOdPrisma,
    errorCercaOdEjePrisma,
    setErrorCercaOdEjePrisma,
    errorCercaOiEsfera,
    setErrorCercaOiEsfera,
    errorCercaOiCilindro,
    setErrorCercaOiCilindro,
    errorCercaOiEje,
    setErrorCercaOiEje,
    errorCercaOiPrisma,
    setErrorCercaOiPrisma,
    errorCercaOiEjePrisma,
    setErrorCercaOiEjePrisma,
    errorIntermediaOdEsfera,
    setErrorIntermediaOdEsfera,
    errorIntermediaOdCilindro,
    setErrorIntermediaOdCilindro,
    errorIntermediaOdEje,
    setErrorIntermediaOdEje,
    errorIntermediaOdPrisma,
    setErrorIntermediaOdPrisma,
    errorIntermediaOdEjePrisma,
    setErrorIntermediaOdEjePrisma,
    errorIntermediaOiEsfera,
    setErrorIntermediaOiEsfera,
    errorIntermediaOiCilindro,
    setErrorIntermediaOiCilindro,
    errorIntermediaOiEje,
    setErrorIntermediaOiEje,
    errorIntermediaOiPrisma,
    setErrorIntermediaOiPrisma,
    errorIntermediaOiEjePrisma,
    setErrorIntermediaOiEjePrisma,
    disabledReceta,
  } = useContext(GestionAtencionContext);

  let {
    lejosCheck,
    lejosOdEsfera,
    lejosOdCilindro,
    lejosOdEje,
    lejosOdPrisma,
    lejosOdPrismaSelect,
    lejosOdEjePrisma,
    lejosOiEsfera,
    lejosOiCilindro,
    lejosOiEje,
    lejosOiPrisma,
    lejosOiPrismaSelect,
    lejosOiEjePrisma,
  } = recetaLejos;

  let {
    cercaCheck,
    cercaOdEsfera,
    cercaOdCilindro,
    cercaOdEje,
    cercaOdPrisma,
    cercaOdPrismaSelect,
    cercaOdEjePrisma,
    cercaOiEsfera,
    cercaOiCilindro,
    cercaOiEje,
    cercaOiPrisma,
    cercaOiPrismaSelect,
    cercaOiEjePrisma,
  } = recetaCerca;

  let {
    intermediaCheck,
    intermediaOdEsfera,
    intermediaOdCilindro,
    intermediaOdEje,
    intermediaOdPrisma,
    intermediaOdPrismaSelect,
    intermediaOdEjePrisma,
    intermediaOiEsfera,
    intermediaOiCilindro,
    intermediaOiEje,
    intermediaOiPrisma,
    intermediaOiPrismaSelect,
    intermediaOiEjePrisma,
  } = recetaIntermedia;

  let { medico, instituto, fechaReceta } = recetaOtrosDatos;
  //
  // ################################################################################
  //
  useEffect(() => {
    loadMedicos();
    loadInstitutos();
  }, []);
  //
  // ################################################################################
  //
  const loadMedicos = async () => {
    const response = await getCacheData("medico")
    if (response.ok) {
      setMedicos(response.data.data);
    } else {
      setMedicos([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadInstitutos = async () => {
    const response = await getCacheData("instituto")
    if (response.ok) {
      setInstitutos(response.data.data);
    } else {
      setInstitutos([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const handleBlur = (e) => {
    let _messageText = "";

    switch (e.target.name) {
      // ################################################################################
      // Esfera

      case "lejosOdEsfera":
        if (
          e.target.value === "" ||
          e.target.value < -30 ||
          e.target.value > 30 ||
          (e.target.value * 100) % 25 !== 0
        ) {
          _messageText = "El valor de esfera de lejos del ojo derecho no es correcto";
          setErrorLejosOdEsfera(true);
        } else {
          setErrorLejosOdEsfera(false);
        }
        break;

      case "lejosOiEsfera":
        if (
          e.target.value === "" ||
          e.target.value < -30 ||
          e.target.value > 30 ||
          (e.target.value * 100) % 25 !== 0
        ) {
          _messageText = "El valor de esfera de lejos del ojo izquierdo no es correcto";
          setErrorLejosOiEsfera(true);
        } else {
          setErrorLejosOiEsfera(false);
        }
        break;

      case "cercaOdEsfera":
        if (
          e.target.value === "" ||
          e.target.value < -30 ||
          e.target.value > 30 ||
          (e.target.value * 100) % 25 !== 0
        ) {
          _messageText = "El valor de esfera de cerca del ojo derecho no es correcto";
          setErrorCercaOdEsfera(true);
        } else {
          setErrorCercaOdEsfera(false);
        }
        break;

      case "cercaOiEsfera":
        if (
          e.target.value === "" ||
          e.target.value < -30 ||
          e.target.value > 30 ||
          (e.target.value * 100) % 25 !== 0
        ) {
          _messageText = "El valor de esfera de cerca del ojo izquierdo no es correcto";
          setErrorCercaOiEsfera(true);
        } else {
          setErrorCercaOiEsfera(false);
        }
        break;

      case "intermediaOdEsfera":
        if (
          e.target.value === "" ||
          e.target.value < -30 ||
          e.target.value > 30 ||
          (e.target.value * 100) % 25 !== 0
        ) {
          _messageText = "El valor de esfera intermedia del ojo derecho no es correcto";
          setErrorIntermediaOdEsfera(true);
        } else {
          setErrorIntermediaOdEsfera(false);
        }
        break;

      case "intermediaOiEsfera":
        if (
          e.target.value === "" ||
          e.target.value < -30 ||
          e.target.value > 30 ||
          (e.target.value * 100) % 25 !== 0
        ) {
          _messageText = "El valor de de esfera intermedia del ojo izquierdo no es correcto";
          setErrorIntermediaOiEsfera(true);
        } else {
          setErrorIntermediaOiEsfera(false);
        }
        break;

      // ################################################################################
      // Cilindro

      case "lejosOdCilindro":
        if (
          e.target.value === "" ||
          e.target.value < -10 ||
          e.target.value > 10 ||
          (e.target.value * 100) % 25 !== 0
        ) {
          _messageText = "El valor de cilindro de lejos del ojo derecho no es correcto";
          setErrorLejosOdCilindro(true);
        } else {
          setErrorLejosOdCilindro(false);
        }
        break;

      case "lejosOiCilindro":
        if (
          e.target.value === "" ||
          e.target.value < -10 ||
          e.target.value > 10 ||
          (e.target.value * 100) % 25 !== 0
        ) {
          _messageText = "El valor de cilindro de lejos del ojo izquierdo no es correcto";
          setErrorLejosOiCilindro(true);
        } else {
          setErrorLejosOiCilindro(false);
        }
        break;

      case "cercaOdCilindro":
        if (
          e.target.value === "" ||
          e.target.value < -10 ||
          e.target.value > 10 ||
          (e.target.value * 100) % 25 !== 0
        ) {
          _messageText = "El valor de cilindro de cerca del ojo derecho no es correcto";
          setErrorCercaOdCilindro(true);
        } else {
          setErrorCercaOdCilindro(false);
        }
        break;

      case "cercaOiCilindro":
        if (
          e.target.value === "" ||
          e.target.value < -10 ||
          e.target.value > 10 ||
          (e.target.value * 100) % 25 !== 0
        ) {
          _messageText = "El valor de cilindro de cerca del ojo izquierdo no es correcto";
          setErrorCercaOiCilindro(true);
        } else {
          setErrorCercaOiCilindro(false);
        }
        break;

      case "intermediaOdCilindro":
        if (
          e.target.value === "" ||
          e.target.value < -10 ||
          e.target.value > 10 ||
          (e.target.value * 100) % 25 !== 0
        ) {
          _messageText = "El valor de cilindro intermedia del ojo derecho no es correcto";
          setErrorIntermediaOdCilindro(true);
        } else {
          setErrorIntermediaOdCilindro(false);
        }
        break;

      case "intermediaOiCilindro":
        if (
          e.target.value === "" ||
          e.target.value < -10 ||
          e.target.value > 10 ||
          (e.target.value * 100) % 25 !== 0
        ) {
          _messageText = "El valor de de esfera intermedia del ojo izquierdo no es correcto";
          setErrorIntermediaOiCilindro(true);
        } else {
          setErrorIntermediaOiCilindro(false);
        }
        break;

      // ################################################################################
      // Eje

      case "lejosOdEje":
        if (e.target.value === "" || e.target.value < 0 || e.target.value > 180) {
          _messageText = "El valor de eje de lejos del ojo derecho no es correcto";
          setErrorLejosOdEje(true);
        } else {
          setErrorLejosOdEje(false);
        }
        break;

      case "lejosOiEje":
        if (e.target.value === "" || e.target.value < 0 || e.target.value > 180) {
          _messageText = "El valor de eje de lejos del ojo izquierdo no es correcto";
          setErrorLejosOiEje(true);
        } else {
          setErrorLejosOiEje(false);
        }
        break;

      case "cercaOdEje":
        if (e.target.value === "" || e.target.value < 0 || e.target.value > 180) {
          _messageText = "El valor de eje de cerca del ojo derecho no es correcto";
          setErrorCercaOdEje(true);
        } else {
          setErrorCercaOdEje(false);
        }
        break;

      case "cercaOiEje":
        if (e.target.value === "" || e.target.value < 0 || e.target.value > 180) {
          _messageText = "El valor de eje de cerca del ojo izquierdo no es correcto";
          setErrorCercaOiEje(true);
        } else {
          setErrorCercaOiEje(false);
        }
        break;

      case "intermediaOdEje":
        if (e.target.value === "" || e.target.value < 0 || e.target.value > 180) {
          _messageText = "El valor de eje intermedia del ojo derecho no es correcto";
          setErrorIntermediaOdEje(true);
        } else {
          setErrorIntermediaOdEje(false);
        }
        break;

      case "intermediaOiEje":
        if (e.target.value === "" || e.target.value < 0 || e.target.value > 180) {
          _messageText = "El valor de de esfera intermedia del ojo izquierdo no es correcto";
          setErrorIntermediaOiEje(true);
        } else {
          setErrorIntermediaOiEje(false);
        }
        break;

      // ################################################################################
      // Prisma

      case "lejosOdPrisma":
        if (e.target.value === "" || e.target.value < 0 || e.target.value > 20) {
          _messageText = "El valor de prisma de lejos del ojo derecho no es correcto";
          setErrorLejosOdPrisma(true);
        } else {
          setErrorLejosOdPrisma(false);
        }
        break;

      case "lejosOiPrisma":
        if (e.target.value === "" || e.target.value < 0 || e.target.value > 20) {
          _messageText = "El valor de prisma de lejos del ojo izquierdo no es correcto";
          setErrorLejosOiPrisma(true);
        } else {
          setErrorLejosOiPrisma(false);
        }
        break;

      case "cercaOdPrisma":
        if (e.target.value === "" || e.target.value < 0 || e.target.value > 20) {
          _messageText = "El valor de prisma de cerca del ojo derecho no es correcto";
          setErrorCercaOdPrisma(true);
        } else {
          setErrorCercaOdPrisma(false);
        }
        break;

      case "cercaOiPrisma":
        if (e.target.value === "" || e.target.value < 0 || e.target.value > 20) {
          _messageText = "El valor de prisma de cerca del ojo izquierdo no es correcto";
          setErrorCercaOiPrisma(true);
        } else {
          setErrorCercaOiPrisma(false);
        }
        break;

      case "intermediaOdPrisma":
        if (e.target.value === "" || e.target.value < 0 || e.target.value > 20) {
          _messageText = "El valor de prisma intermedia del ojo derecho no es correcto";
          setErrorIntermediaOdPrisma(true);
        } else {
          setErrorIntermediaOdPrisma(false);
        }
        break;

      case "intermediaOiPrisma":
        if (e.target.value === "" || e.target.value < 0 || e.target.value > 20) {
          _messageText = "El valor de de esfera intermedia del ojo izquierdo no es correcto";
          setErrorIntermediaOiPrisma(true);
        } else {
          setErrorIntermediaOiPrisma(false);
        }
        break;

      // ################################################################################
      // Eje Prisma

      case "lejosOdEjePrisma":
        if (e.target.value === "" || e.target.value < 0 || e.target.value > 10) {
          _messageText = "El valor de eje prisma de lejos del ojo derecho no es correcto";
          setErrorLejosOdEjePrisma(true);
        } else {
          setErrorLejosOdEjePrisma(false);
        }
        break;

      case "lejosOiEjePrisma":
        if (e.target.value === "" || e.target.value < 0 || e.target.value > 10) {
          _messageText = "El valor de eje prisma de lejos del ojo izquierdo no es correcto";
          setErrorLejosOiEjePrisma(true);
        } else {
          setErrorLejosOiEjePrisma(false);
        }
        break;

      case "cercaOdEjePrisma":
        if (e.target.value === "" || e.target.value < 0 || e.target.value > 10) {
          _messageText = "El valor de eje prisma de cerca del ojo derecho no es correcto";
          setErrorCercaOdEjePrisma(true);
        } else {
          setErrorCercaOdEjePrisma(false);
        }
        break;

      case "cercaOiEjePrisma":
        if (e.target.value === "" || e.target.value < 0 || e.target.value > 10) {
          _messageText = "El valor de eje prisma de cerca del ojo izquierdo no es correcto";
          setErrorCercaOiEjePrisma(true);
        } else {
          setErrorCercaOiEjePrisma(false);
        }
        break;

      case "intermediaOdEjePrisma":
        if (e.target.value === "" || e.target.value < 0 || e.target.value > 10) {
          _messageText = "El valor de eje prisma intermedia del ojo derecho no es correcto";
          setErrorIntermediaOdEjePrisma(true);
        } else {
          setErrorIntermediaOdEjePrisma(false);
        }
        break;

      case "intermediaOiEjePrisma":
        if (e.target.value === "" || e.target.value < 0 || e.target.value > 10) {
          _messageText = "El valor de de esfera intermedia del ojo izquierdo no es correcto";
          setErrorIntermediaOiEjePrisma(true);
        } else {
          setErrorIntermediaOiEjePrisma(false);
        }
        break;

      default:
    }

    if (_messageText) {
      setMessage({
        messageText: _messageText,
        severity: "error",
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const handleReloadMedicos = () => {
    loadMedicos();
  };
  //
  // ################################################################################
  //
  const handleReloadInstitutos = () => {
    loadInstitutos();
  };
  //
  // ################################################################################
  //
  return (
    <Paper elevation={3} sx={{ m: 1, p: 2 }}>
      <Box sx={{ m: 2, mb: 4 }}>
        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12} sm={12} md={6} lg={4}>
            <FormControl
              disabled={disabledReceta}
              fullWidth
            >
              <InputLabel id="medico-select-label">Médico</InputLabel>
              <Select
                labelId="medico-select-label"
                id="medico-select"
                name="medico"
                value={medicos.length > 0 ? medico : ""}
                label="Médico"
                size="small"
                onChange={handleChangeRecetaOtrosDatos}
                MenuProps={{ style: { maxHeight: "auto" } }}
                input={
                  <OutlinedInput
                    label="Seleccionar"
                    endAdornment={
                      <InputAdornment position="end" sx={{ mr: 2 }}>
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            loadMedicos();
                          }}
                          onMouseDown={(e) => e.stopPropagation()}
                          disabled={disabledReceta}
                        >
                          <RefreshOutlinedIcon sx={{ fontSize: 16 }} />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                }
              >
                {medicos.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.apellido + ", " + item.nombre + (item.numero_matricula ? " ( Matr: " + item.numero_matricula + ")" : "")}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={4}>
            <FormControl
              disabled={disabledReceta}
              fullWidth
            >
              <InputLabel id="instituto-select-label">Institución Médica</InputLabel>
              <Select
                labelId="instituto-select-label"
                id="instituto-select"
                name="instituto"
                value={institutos.length > 0 ? instituto : ""}
                label="Institución Médica"
                size="small"
                onChange={handleChangeRecetaOtrosDatos}
                MenuProps={{ style: { maxHeight: "300px" } }}
                input={
                  <OutlinedInput
                    label="Seleccionar"
                    endAdornment={
                      <InputAdornment position="end" sx={{ mr: 2 }}>
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            loadInstitutos();
                          }}
                          onMouseDown={(e) => e.stopPropagation()}
                          disabled={disabledReceta}
                        >
                          <RefreshOutlinedIcon sx={{ fontSize: 16 }} />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                }
              >
                {institutos.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.descripcion}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={2}>
            <DatePicker
              sx={{
                width: "100%",
                mb: 1,
                '& .MuiInputLabel-root': {
                  transform: 'translate(14px, 9px) scale(1)',
                },
                '& .MuiInputBase-root': {
                  paddingRight: '10px',
                },
                '& .MuiInputLabel-shrink': {
                  transform: 'translate(14px, -8px) scale(0.75)',
                },
              }}
              id="fechaReceta"
              label="Fecha de Receta"
              variant="outlined"
              name="fechaReceta"
              value={fechaReceta}
              format="dd/MM/yyyy"
              maxDate={new Date()}
              onChange={(newValue) => handleChangeRecetaOtrosDatosFechaReceta(newValue)}
              slots={{ textField: TextField }}
              slotProps={{
                textField: {
                  size: "small",
                  sx: { width: "100%" },
                },
              }}
              disabled={disabledReceta}
            />
          </Grid>
        </Grid>
      </Box>

      <Box sx={{ m: 2 }}>
        <Box sx={{ border: "1px solid LightGrey", borderRadius: "5px", mx: 5, mb: 1, p: 2 }}>
          <Grid container spacing={1}>
            <Grid item sm={12}>
              <FormControlLabel
                sx={{ mx: "auto" }}
                control={
                  <Checkbox
                    id="lejos-check"
                    name="lejosCheck"
                    checked={lejosCheck}
                    onChange={handleChangeRecetaLejos}
                    disabled={recetaLejosDisabled || disabledReceta}
                  />
                }
                label="LEJOS"
              />
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item sm={1}></Grid>
            <Grid item sm={2}>
              <Typography component="div" gutterBottom align="center">
                Esfera
              </Typography>
            </Grid>
            <Grid item sm={2}>
              <Typography component="div" gutterBottom align="center">
                Cilindro
              </Typography>
            </Grid>
            <Grid item sm={2}>
              <Typography component="div" gutterBottom align="center">
                Eje
              </Typography>
            </Grid>
            <Grid item sm={3}>
              <Typography component="div" gutterBottom align="center">
                Prisma
              </Typography>
            </Grid>
            <Grid item sm={2}>
              <Typography component="div" gutterBottom align="center">
                Eje prisma
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={0.5} sx={{ mb: 1 }}>
            <Grid item sm={1}>
              <Typography component="div" gutterBottom align="center" sx={{ fontWeight: "bold" }}>
                OD
              </Typography>
            </Grid>
            <Grid item sm={2}>
              <TextField
                inputProps={{
                  style: { textAlign: "center" },
                  maxLength: 6,
                  type: "number",
                  step: 0.25,
                }}
                id="lejos-esfera-od"
                size="small"
                name="lejosOdEsfera"
                value={lejosOdEsfera}
                onChange={handleChangeRecetaLejos}
                disabled={!lejosCheck || recetaLejosDisabled || disabledReceta}
                onBlur={handleBlur}
                error={errorLejosOdEsfera}
              />
            </Grid>
            <Grid item sm={2}>
              <TextField
                inputProps={{
                  style: { textAlign: "center" },
                  maxLength: 6,
                  type: "number",
                  step: 0.25,
                }}
                id="lejos-cilindro-od"
                size="small"
                name="lejosOdCilindro"
                value={lejosOdCilindro}
                onChange={handleChangeRecetaLejos}
                disabled={!lejosCheck || recetaLejosDisabled || disabledReceta}
                onBlur={handleBlur}
                error={errorLejosOdCilindro}
              />
            </Grid>
            <Grid item sm={2}>
              <TextField
                inputProps={{
                  style: { textAlign: "center" },
                  maxLength: 6,
                  type: "number",
                  step: 1,
                }}
                id="lejos-eje-od"
                size="small"
                name="lejosOdEje"
                value={lejosOdEje}
                onChange={handleChangeRecetaLejos}
                disabled={!lejosCheck || recetaLejosDisabled || disabledReceta}
                onBlur={handleBlur}
                error={errorLejosOdEje}
              />
            </Grid>
            <Grid item sm={3}>
              <TextField
                sx={{ maxWidth: "30%" }}
                inputProps={{
                  style: { textAlign: "center" },
                  maxLength: 6,
                  type: "number",
                  step: 1,
                }}
                id="lejos-prisma-od"
                size="small"
                name="lejosOdPrisma"
                value={lejosOdPrisma}
                onChange={handleChangeRecetaLejos}
                disabled={!lejosCheck || recetaLejosDisabled || disabledReceta}
                onBlur={handleBlur}
                error={errorLejosOdPrisma}
              />
              <FormControl
                fullWidth
                disabled={!lejosCheck || recetaLejosDisabled || disabledReceta}
                sx={{ maxWidth: "70%" }}
              >
                <Select
                  labelId="lejos-prisma-select-od-label"
                  id="lejos-prisma-select-od"
                  name="lejosOdPrismaSelect"
                  value={lejosOdPrismaSelect}
                  size="small"
                  onChange={handleChangeRecetaLejos}
                >
                  {prismaOptions.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.descripcion}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item sm={2}>
              <TextField
                inputProps={{
                  style: { textAlign: "center" },
                  maxLength: 6,
                  type: "number",
                  step: 1,
                }}
                id="lejos-eje-prisma-od"
                size="small"
                name="lejosOdEjePrisma"
                value={lejosOdEjePrisma}
                onChange={handleChangeRecetaLejos}
                disabled={!lejosCheck || recetaLejosDisabled || disabledReceta}
                onBlur={handleBlur}
                error={errorLejosOdEjePrisma}
              />
            </Grid>
          </Grid>

          {/* Lejos OI */}

          <Grid container spacing={0.5}>
            <Grid item sm={1}>
              <Typography component="div" gutterBottom align="center" sx={{ fontWeight: "bold" }}>
                OI
              </Typography>
            </Grid>
            <Grid item sm={2}>
              <TextField
                inputProps={{
                  style: { textAlign: "center" },
                  maxLength: 6,
                  type: "number",
                  step: 0.25,
                }}
                id="lejos-esfera-oi"
                size="small"
                name="lejosOiEsfera"
                value={lejosOiEsfera}
                onChange={handleChangeRecetaLejos}
                disabled={!lejosCheck || recetaLejosDisabled || disabledReceta}
                onBlur={handleBlur}
                error={errorLejosOiEsfera}
              />
            </Grid>
            <Grid item sm={2}>
              <TextField
                inputProps={{
                  style: { textAlign: "center" },
                  maxLength: 6,
                  type: "number",
                  step: 0.25,
                }}
                id="lejos-cilindro-oi"
                size="small"
                name="lejosOiCilindro"
                value={lejosOiCilindro}
                onChange={handleChangeRecetaLejos}
                disabled={!lejosCheck || recetaLejosDisabled || disabledReceta}
                onBlur={handleBlur}
                error={errorLejosOiCilindro}
              />
            </Grid>
            <Grid item sm={2}>
              <TextField
                inputProps={{
                  style: { textAlign: "center" },
                  maxLength: 6,
                  type: "number",
                  step: 1,
                }}
                id="lejos-eje-oi"
                size="small"
                name="lejosOiEje"
                value={lejosOiEje}
                onChange={handleChangeRecetaLejos}
                disabled={!lejosCheck || recetaLejosDisabled || disabledReceta}
                onBlur={handleBlur}
                error={errorLejosOiEje}
              />
            </Grid>
            <Grid item sm={3}>
              <TextField
                sx={{ maxWidth: "30%" }}
                inputProps={{
                  style: { textAlign: "center" },
                  maxLength: 6,
                  type: "number",
                  step: 1,
                }}
                id="lejos-prisma-oi"
                size="small"
                name="lejosOiPrisma"
                value={lejosOiPrisma}
                onChange={handleChangeRecetaLejos}
                disabled={!lejosCheck || recetaLejosDisabled || disabledReceta}
                onBlur={handleBlur}
                error={errorLejosOiPrisma}
              />
              <FormControl
                fullWidth
                disabled={!lejosCheck || recetaLejosDisabled || disabledReceta}
                sx={{ maxWidth: "70%" }}
              >
                <Select
                  labelId="lejos-prisma-select-od-label"
                  id="lejos-prisma-select-od"
                  name="lejosOiPrismaSelect"
                  value={lejosOiPrismaSelect}
                  size="small"
                  onChange={handleChangeRecetaLejos}
                >
                  {prismaOptions.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.descripcion}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item sm={2}>
              <TextField
                inputProps={{
                  style: { textAlign: "center" },
                  maxLength: 6,
                  type: "number",
                  step: 1,
                }}
                id="lejos-eje-prisma-oi"
                size="small"
                name="lejosOiEjePrisma"
                value={lejosOiEjePrisma}
                onChange={handleChangeRecetaLejos}
                disabled={!lejosCheck || recetaLejosDisabled || disabledReceta}
                onBlur={handleBlur}
                error={errorLejosOiEjePrisma}
              />
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ border: "1px solid LightGrey", borderRadius: "5px", mx: 5, mb: 1, p: 2 }}>
          {/* Check */}
          <Grid container spacing={2}>
            <Grid item sm={12}>
              <FormControlLabel
                sx={{ mx: "auto" }}
                control={
                  <Checkbox
                    id="cerca-check"
                    name="cercaCheck"
                    checked={cercaCheck}
                    onChange={handleChangeRecetaCerca}
                    disabled={recetaCercaDisabled || disabledReceta}
                  />
                }
                label="CERCA"
              />
            </Grid>
          </Grid>
          {/* Cerca encabezados */}
          <Grid container spacing={2}>
            <Grid item sm={1}></Grid>
            <Grid item sm={2}>
              <Typography component="div" gutterBottom align="center">
                Esfera
              </Typography>
            </Grid>
            <Grid item sm={2}>
              <Typography component="div" gutterBottom align="center">
                Cilindro
              </Typography>
            </Grid>
            <Grid item sm={2}>
              <Typography component="div" gutterBottom align="center">
                Eje
              </Typography>
            </Grid>
            <Grid item sm={3}>
              <Typography component="div" gutterBottom align="center">
                Prisma
              </Typography>
            </Grid>
            <Grid item sm={2}>
              <Typography component="div" gutterBottom align="center">
                Eje prisma
              </Typography>
            </Grid>
          </Grid>

          {/* Cerca OD */}

          <Grid container spacing={0.5} sx={{ mb: 1 }}>
            <Grid item sm={1}>
              <Typography component="div" gutterBottom align="center" sx={{ fontWeight: "bold" }}>
                OD
              </Typography>
            </Grid>
            <Grid item sm={2}>
              <TextField
                inputProps={{
                  style: { textAlign: "center" },
                  maxLength: 6,
                  type: "number",
                  step: 0.25,
                }}
                id="cerca-esfera-od"
                size="small"
                name="cercaOdEsfera"
                value={cercaOdEsfera}
                onChange={handleChangeRecetaCerca}
                disabled={!cercaCheck || recetaCercaDisabled || disabledReceta}
                onBlur={handleBlur}
                error={errorCercaOdEsfera}
              />
            </Grid>
            <Grid item sm={2}>
              <TextField
                inputProps={{
                  style: { textAlign: "center" },
                  maxLength: 6,
                  type: "number",
                  step: 0.25,
                }}
                id="cerca-cilindro-od"
                size="small"
                name="cercaOdCilindro"
                value={cercaOdCilindro}
                onChange={handleChangeRecetaCerca}
                disabled={!cercaCheck || recetaCercaDisabled || disabledReceta}
                onBlur={handleBlur}
                error={errorCercaOdCilindro}
              />
            </Grid>
            <Grid item sm={2}>
              <TextField
                inputProps={{
                  style: { textAlign: "center" },
                  maxLength: 6,
                  type: "number",
                  step: 1,
                }}
                id="cerca-eje-od"
                size="small"
                name="cercaOdEje"
                value={cercaOdEje}
                onChange={handleChangeRecetaCerca}
                disabled={!cercaCheck || recetaCercaDisabled || disabledReceta}
                onBlur={handleBlur}
                error={errorCercaOdEje}
              />
            </Grid>
            <Grid item sm={3}>
              <TextField
                sx={{ maxWidth: "30%" }}
                inputProps={{
                  style: { textAlign: "center" },
                  maxLength: 6,
                  type: "number",
                  step: 1,
                }}
                id="cerca-prisma-od"
                size="small"
                name="cercaOdPrisma"
                value={cercaOdPrisma}
                onChange={handleChangeRecetaCerca}
                disabled={!cercaCheck || recetaCercaDisabled || disabledReceta}
                onBlur={handleBlur}
                error={errorCercaOdPrisma}
              />
              <FormControl
                fullWidth
                disabled={!cercaCheck || recetaCercaDisabled || disabledReceta}
                sx={{ maxWidth: "70%" }}
              >
                <Select
                  labelId="cerca-prisma-select-od-label"
                  id="cerca-prisma-select-od"
                  name="cercaOdPrismaSelect"
                  value={cercaOdPrismaSelect}
                  size="small"
                  onChange={handleChangeRecetaCerca}
                >
                  {prismaOptions.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.descripcion}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item sm={2}>
              <TextField
                inputProps={{
                  style: { textAlign: "center" },
                  maxLength: 6,
                  type: "number",
                  step: 1,
                }}
                id="cerca-eje-prisma-od"
                size="small"
                name="cercaOdEjePrisma"
                value={cercaOdEjePrisma}
                onChange={handleChangeRecetaCerca}
                disabled={!cercaCheck || recetaCercaDisabled || disabledReceta}
                onBlur={handleBlur}
                error={errorCercaOdEjePrisma}
              />
            </Grid>
          </Grid>

          {/* Cerca OI */}

          <Grid container spacing={0.5}>
            <Grid item sm={1}>
              <Typography component="div" gutterBottom align="center" sx={{ fontWeight: "bold" }}>
                OI
              </Typography>
            </Grid>
            <Grid item sm={2}>
              <TextField
                inputProps={{
                  style: { textAlign: "center" },
                  maxLength: 6,
                  type: "number",
                  step: 0.25,
                }}
                id="cerca-esfera-oi"
                size="small"
                name="cercaOiEsfera"
                value={cercaOiEsfera}
                onChange={handleChangeRecetaCerca}
                disabled={!cercaCheck || recetaCercaDisabled || disabledReceta}
                onBlur={handleBlur}
                error={errorCercaOiEsfera}
              />
            </Grid>
            <Grid item sm={2}>
              <TextField
                inputProps={{
                  style: { textAlign: "center" },
                  maxLength: 6,
                  type: "number",
                  step: 0.25,
                }}
                id="cerca-cilindro-oi"
                size="small"
                name="cercaOiCilindro"
                value={cercaOiCilindro}
                onChange={handleChangeRecetaCerca}
                disabled={!cercaCheck || recetaCercaDisabled || disabledReceta}
                onBlur={handleBlur}
                error={errorCercaOiCilindro}
              />
            </Grid>
            <Grid item sm={2}>
              <TextField
                inputProps={{
                  style: { textAlign: "center" },
                  maxLength: 6,
                  type: "number",
                  step: 1,
                }}
                id="cerca-eje-oi"
                size="small"
                name="cercaOiEje"
                value={cercaOiEje}
                onChange={handleChangeRecetaCerca}
                disabled={!cercaCheck || recetaCercaDisabled || disabledReceta}
                onBlur={handleBlur}
                error={errorCercaOiEje}
              />
            </Grid>
            <Grid item sm={3}>
              <TextField
                sx={{ maxWidth: "30%" }}
                inputProps={{
                  style: { textAlign: "center" },
                  maxLength: 6,
                  type: "number",
                  step: 1,
                }}
                id="cerca-prisma-oi"
                size="small"
                name="cercaOiPrisma"
                value={cercaOiPrisma}
                onChange={handleChangeRecetaCerca}
                disabled={!cercaCheck || recetaCercaDisabled || disabledReceta}
                onBlur={handleBlur}
                error={errorCercaOiPrisma}
              />
              <FormControl
                fullWidth
                disabled={!cercaCheck || recetaCercaDisabled || disabledReceta}
                sx={{ maxWidth: "70%" }}
              >
                <Select
                  labelId="cerca-prisma-select-od-label"
                  id="cerca-prisma-select-od"
                  name="cercaOiPrismaSelect"
                  value={cercaOiPrismaSelect}
                  size="small"
                  onChange={handleChangeRecetaCerca}
                >
                  {prismaOptions.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.descripcion}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item sm={2}>
              <TextField
                inputProps={{
                  style: { textAlign: "center" },
                  maxLength: 6,
                  type: "number",
                  step: 1,
                }}
                id="cerca-eje-prisma-oi"
                size="small"
                name="cercaOiEjePrisma"
                value={cercaOiEjePrisma}
                onChange={handleChangeRecetaCerca}
                disabled={!cercaCheck || recetaCercaDisabled || disabledReceta}
                onBlur={handleBlur}
                error={errorCercaOiEjePrisma}
              />
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ border: "1px solid LightGrey", borderRadius: "5px", mx: 5, mb: 1, p: 2 }}>
          {/* Check */}

          <Grid container spacing={2}>
            <Grid item sm={12}>
              <FormControlLabel
                sx={{ mx: "auto" }}
                control={
                  <Checkbox
                    id="intermedia-check"
                    name="intermediaCheck"
                    checked={intermediaCheck}
                    onChange={handleChangeRecetaIntermedia}
                    disabled={recetaIntermediaDisabled || disabledReceta}
                  />
                }
                label="INTERMEDIA"
              />
            </Grid>
          </Grid>
          {/* Intermedia encabezados */}
          <Grid container spacing={2}>
            <Grid item sm={1}></Grid>
            <Grid item sm={2}>
              <Typography component="div" gutterBottom align="center">
                Esfera
              </Typography>
            </Grid>
            <Grid item sm={2}>
              <Typography component="div" gutterBottom align="center">
                Cilindro
              </Typography>
            </Grid>
            <Grid item sm={2}>
              <Typography component="div" gutterBottom align="center">
                Eje
              </Typography>
            </Grid>
            <Grid item sm={3}>
              <Typography component="div" gutterBottom align="center">
                Prisma
              </Typography>
            </Grid>
            <Grid item sm={2}>
              <Typography component="div" gutterBottom align="center">
                Eje prisma
              </Typography>
            </Grid>
          </Grid>

          {/* Inermedia OD */}

          <Grid container spacing={0.5} sx={{ mb: 1 }}>
            <Grid item sm={1}>
              <Typography component="div" gutterBottom align="center" sx={{ fontWeight: "bold" }}>
                OD
              </Typography>
            </Grid>
            <Grid item sm={2}>
              <TextField
                inputProps={{
                  style: { textAlign: "center" },
                  maxLength: 6,
                  type: "number",
                  step: 0.25,
                }}
                id="intermedia-esfera-od"
                size="small"
                name="intermediaOdEsfera"
                value={intermediaOdEsfera}
                onChange={handleChangeRecetaIntermedia}
                disabled={!intermediaCheck || recetaIntermediaDisabled || disabledReceta}
                onBlur={handleBlur}
                error={errorIntermediaOdEsfera}
              />
            </Grid>
            <Grid item sm={2}>
              <TextField
                inputProps={{
                  style: { textAlign: "center" },
                  maxLength: 6,
                  type: "number",
                  step: 0.25,
                }}
                id="intermedia-cilindro-od"
                size="small"
                name="intermediaOdCilindro"
                value={intermediaOdCilindro}
                onChange={handleChangeRecetaIntermedia}
                disabled={!intermediaCheck || recetaIntermediaDisabled || disabledReceta}
                onBlur={handleBlur}
                error={errorIntermediaOdCilindro}
              />
            </Grid>
            <Grid item sm={2}>
              <TextField
                inputProps={{
                  style: { textAlign: "center" },
                  maxLength: 6,
                  type: "number",
                  step: 1,
                }}
                id="intermedia-eje-od"
                size="small"
                name="intermediaOdEje"
                value={intermediaOdEje}
                onChange={handleChangeRecetaIntermedia}
                disabled={!intermediaCheck || recetaIntermediaDisabled || disabledReceta}
                onBlur={handleBlur}
                error={errorIntermediaOdEje}
              />
            </Grid>
            <Grid item sm={3}>
              <TextField
                sx={{ maxWidth: "30%" }}
                inputProps={{
                  style: { textAlign: "center" },
                  maxLength: 6,
                  type: "number",
                  step: 1,
                }}
                id="intermedia-prisma-od"
                size="small"
                name="intermediaOdPrisma"
                value={intermediaOdPrisma}
                onChange={handleChangeRecetaIntermedia}
                disabled={!intermediaCheck || recetaIntermediaDisabled || disabledReceta}
                onBlur={handleBlur}
                error={errorIntermediaOdPrisma}
              />
              <FormControl
                fullWidth
                disabled={!intermediaCheck || recetaIntermediaDisabled || disabledReceta}
                sx={{ maxWidth: "70%" }}
              >
                <Select
                  labelId="intermedia-prisma-select-od-label"
                  id="intermedia-prisma-select-od"
                  name="intermediaOdPrismaSelect"
                  value={intermediaOdPrismaSelect}
                  size="small"
                  onChange={handleChangeRecetaIntermedia}
                >
                  {prismaOptions.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.descripcion}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item sm={2}>
              <TextField
                inputProps={{
                  style: { textAlign: "center" },
                  maxLength: 6,
                  type: "number",
                  step: 1,
                }}
                id="intermedia-eje-prisma-od"
                size="small"
                name="intermediaOdEjePrisma"
                value={intermediaOdEjePrisma}
                onChange={handleChangeRecetaIntermedia}
                disabled={!intermediaCheck || recetaIntermediaDisabled || disabledReceta}
                onBlur={handleBlur}
                error={errorIntermediaOdEjePrisma}
              />
            </Grid>
          </Grid>

          {/* Intermedia OI */}

          <Grid container spacing={0.5}>
            <Grid item sm={1}>
              <Typography component="div" gutterBottom align="center" sx={{ fontWeight: "bold" }}>
                OI
              </Typography>
            </Grid>
            <Grid item sm={2}>
              <TextField
                inputProps={{
                  style: { textAlign: "center" },
                  maxLength: 6,
                  type: "number",
                  step: 0.25,
                }}
                id="intermedia-esfera-oi"
                size="small"
                name="intermediaOiEsfera"
                value={intermediaOiEsfera}
                onChange={handleChangeRecetaIntermedia}
                disabled={!intermediaCheck || recetaIntermediaDisabled || disabledReceta}
                onBlur={handleBlur}
                error={errorIntermediaOiEsfera}
              />
            </Grid>
            <Grid item sm={2}>
              <TextField
                inputProps={{
                  style: { textAlign: "center" },
                  maxLength: 6,
                  type: "number",
                  step: 0.25,
                }}
                id="intermedia-cilindro-oi"
                size="small"
                name="intermediaOiCilindro"
                value={intermediaOiCilindro}
                onChange={handleChangeRecetaIntermedia}
                disabled={!intermediaCheck || recetaIntermediaDisabled || disabledReceta}
                onBlur={handleBlur}
                error={errorIntermediaOiCilindro}
              />
            </Grid>
            <Grid item sm={2}>
              <TextField
                inputProps={{
                  style: { textAlign: "center" },
                  maxLength: 6,
                  type: "number",
                  step: 1,
                }}
                id="intermedia-eje-oi"
                size="small"
                name="intermediaOiEje"
                value={intermediaOiEje}
                onChange={handleChangeRecetaIntermedia}
                disabled={!intermediaCheck || recetaIntermediaDisabled || disabledReceta}
                onBlur={handleBlur}
                error={errorIntermediaOiEje}
              />
            </Grid>
            <Grid item sm={3}>
              <TextField
                sx={{ maxWidth: "30%" }}
                inputProps={{
                  style: { textAlign: "center" },
                  maxLength: 6,
                  type: "number",
                  step: 1,
                }}
                id="intermedia-prisma-oi"
                size="small"
                name="intermediaOiPrisma"
                value={intermediaOiPrisma}
                onChange={handleChangeRecetaIntermedia}
                disabled={!intermediaCheck || recetaIntermediaDisabled || disabledReceta}
                onBlur={handleBlur}
                error={errorIntermediaOiPrisma}
              />
              <FormControl
                fullWidth
                disabled={!intermediaCheck || recetaIntermediaDisabled || disabledReceta}
                sx={{ maxWidth: "70%" }}
              >
                <Select
                  labelId="intermedia-prisma-select-od-label"
                  id="intermedia-prisma-select-od"
                  name="intermediaOiPrismaSelect"
                  value={intermediaOiPrismaSelect}
                  size="small"
                  onChange={handleChangeRecetaIntermedia}
                >
                  {prismaOptions.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.descripcion}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item sm={2}>
              <TextField
                inputProps={{
                  style: { textAlign: "center" },
                  maxLength: 6,
                  type: "number",
                  step: 1,
                }}
                id="intermedia-eje-prisma-oi"
                size="small"
                name="intermediaOiEjePrisma"
                value={intermediaOiEjePrisma}
                onChange={handleChangeRecetaIntermedia}
                disabled={!intermediaCheck || recetaIntermediaDisabled || disabledReceta}
                onBlur={handleBlur}
                error={errorIntermediaOiEjePrisma}
              />
            </Grid>
          </Grid>
        </Box>
      </Box>

      {/* >>>> Messages */}

      {showMessage && (
        <Message showMessage={showMessage} setShowMessage={setShowMessage} message={message} />
      )}
    </Paper>
  );
};
export default Receta;